import { put, takeLatest, call } from 'redux-saga/effects';

import { api } from '../../../../../api';

import { hotelImagesFetched } from './actions';
import { FETCH_HOTEL_IMAGES } from './constants';

function* fetchHotelImages(id) {
  const { hotels } = yield api.getReferencesHotelsImages({ hotel_ids: id });

  const [hotelInfo] = hotels;
  return hotelInfo.images;
}

function* fetchHotel(action) {
  const id = action.payload;
  const images = yield call(fetchHotelImages, id);
  yield put(hotelImagesFetched({ id, images }));
}

export default function* () {
  yield takeLatest(FETCH_HOTEL_IMAGES, fetchHotel);
}
